import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import {HttpClientModule, HttpClient, HTTP_INTERCEPTORS} from '@angular/common/http';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslatePoHttpLoader } from '@biesbjerg/ngx-translate-po-http-loader';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { QuillModule } from 'ngx-quill';
import { SimpleNotificationsModule } from 'angular2-notifications'
import { InlineHrefDirective } from 'ng-inline-href';
import { InlineSVGModule } from 'ng-inline-svg';
import { DragulaModule } from 'ng2-dragula'
import { TokenInterceptor } from "app/authorized-http.service";
import { OnclickoutDirective } from './onclickout.directive';
import { LoginComponent } from './login/login.component';
import { LoginDataService } from "app/login/login-data.service";
import { IsUserLoggedGuard } from "app/login/is-user-logged.guard";
import { DisableLoginGuard } from "app/login/disable-login.guard";
import { HomeComponent } from './home/home.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TextContentComponent } from './text-content/text-content.component';
import { UserListComponent } from './user/user-list/user-list.component';
import { AddUserComponent } from './user/add-user/add-user.component';
import { EditUserComponent } from './user/edit-user/edit-user.component';
import { UtilsService } from "app/services/utils.service";
import { ReactiveFormsModule } from '@angular/forms';
import { MyProfileComponent } from './user/my-profile/my-profile.component';
import { TranslateJsPipe } from './translate-js-pipe.pipe';
import { ChartsModule } from 'ng2-charts';
import { DatePickerComponent } from 'app/calendar/ng2-datepicker.component';
import { PaginationComponent } from './pagination/pagination.component';
import { ImagePipePipe } from './image-pipe.pipe';
import { ImageCropperModule } from 'ng2-img-cropper';
import { DateTimePickerModule } from 'ng-pick-datetime';
import { CookiePolicyComponent } from 'app/footer/cookie-policy/cookie-policy.component';
import { TermsAndConditionsComponent } from 'app/footer/terms-and-conditions/terms-and-conditions.component';
import { Ng2DeviceDetectorModule } from 'ng2-device-detector';
import { BrowserFailComponent } from './browser-fail/browser-fail.component';
import { TinyMceComponent } from 'app/tinymce-editor/tinymce-editor.component';
import { TooltipModule } from 'ng2-tooltip-directive';
import { TinyMceSmallEditorComponent } from 'app/tinymce-small-editor/tinymce-small-editor';
import { FooterConfigComponent } from './homepage-configuration/footer-config/footer-config.component';
import { SortPipe } from "app/sort";
import { EditColumnComponent } from 'app/homepage-configuration/footer-config/edit-column/edit-column.component';
import { FooterStyleConfigComponent } from 'app/homepage-configuration/footer-config/footer-style-config/footer-style-config.component';
import { FooterColumnShiftComponent } from 'app/homepage-configuration/footer-config/footer-column-shift/footer-column-shift.component';
import { FooterPagesComponent } from 'app/homepage-configuration/footer-config/footer-pages/footer-pages.component';
import { FooterPageListComponent } from 'app/homepage-configuration/footer-config/footer-page-list/footer-page-list.component';
import { HeaderBodyComponent } from 'app/homepage-configuration/header/header-body/header-body.component';
import { HeaderTopBarComponent } from 'app/homepage-configuration/header/header-top-bar/header-top-bar.component';
import { HeaderStyleConfigComponent } from 'app/homepage-configuration/header/header-style-config/header-style-config.component';
import { Globals } from 'app/services/globals';
import { MessageService } from "app/message-service.service";
import { NewsIntranetComponent } from './news-intranet/news-intranet.component';
import { CategoriesListComponent } from './news-intranet/categories-list/categories-list.component';
import { EditCategoryComponent } from './news-intranet/edit-category/edit-category.component';
import { EditNewsIntranetComponent } from './news-intranet/edit-news-intranet/edit-news-intranet.component';
import { VisitingHoursComponent } from './visiting-hours/visiting-hours.component';
import { AddEditFieldComponent } from './visiting-hours/add-edit-field/add-edit-field.component';
import { AddEditDepartmentComponent } from './visiting-hours/add-edit-department/add-edit-department.component';
import { NewsletterListComponent } from './newsletter/newsletter-list/newsletter-list.component';
import { NewsletterSubscribersComponent } from './newsletter/newsletter-subscribers/newsletter-subscribers.component';
import { NewsletterSettingsComponent } from './newsletter/newsletter-settings/newsletter-settings.component';
import { NewsletterAddSubscriberComponent } from './newsletter/newsletter-subscribers/newsletter-add-subscriber/newsletter-add-subscriber.component';
import { AddNewsletterComponent } from './newsletter/add-newsletter/add-newsletter.component';
import { GdprCreateSubscribeComponent } from './gdpr-create-subscribe/gdpr-create-subscribe.component';
import { UnsubscribeNewsletterComponent } from './unsubscribe-newsletter/unsubscribe-newsletter.component';
import { GdprComponent } from './gdpr/gdpr.component';
import { SliderComponent } from './homepage-configuration/slider/slider.component';
import { ShortFooterComponent } from './homepage-configuration/short-footer/short-footer.component';
import { WelcomeComponent } from './homepage-configuration/welcome/welcome.component';
import { FaqComponent } from './faq/faq/faq.component';
import { AddEditFaqComponent } from './faq/add-edit-faq/add-edit-faq.component';
import { KioskResource } from './models/KioskResource';
import { KioskComponent } from './kiosk/kiosk.component';
import { AddEditKioskComponent } from './kiosk/add-edit-kiosk/add-edit-kiosk.component';
import { AddEditTextContentComponent } from './text-content/add-edit-text-content/add-edit-text-content.component';
import { UsefulContactsComponent } from './homepage-configuration/short-footer/useful-contacts/useful-contacts.component';
import { FooterListComponent } from './homepage-configuration/short-footer/footer-list/footer-list.component';
import { SliderListComponent } from './homepage-configuration/slider/slider-list/slider-list.component';
import { WelcomeListComponent } from './homepage-configuration/welcome/welcome-list/welcome-list.component';
import { ForgotPasswordConfirmComponent } from './forgot-password-confirm/forgot-password-confirm.component';
import { DepartmentsListComponent } from './appointments/departments-list/departments-list.component';
import { AppointmentsListComponent } from './appointments/appointments-list/appointments-list.component';
import { BasicAuthInterceptor } from './basic-auth.interceptor';
import { AddEditAppointmentComponent } from './appointments/appointments-list/add-edit-appointment/add-edit-appointment.component';
import { AppointmentsOfficersListComponent } from './appointments/appointments-officers-list/appointments-officers-list.component';
import { AddEditAppointmentOfficerComponent } from './appointments/appointments-officers-list/add-edit-appointment-officer/add-edit-appointment-officer.component';
import { AddUserService } from './user/add-user/add-user.service';
import { UserListService } from './user/user-list/user-list.service';
import { AddEditAppointmentDepartmentComponent } from './appointments/departments-list/add-edit-appointment-department/add-edit-appointment-department.component';
import {CalendarModule} from 'primeng/calendar';
import { ModuleSettingsComponent } from './module-settings/module-settings.component';
import { KioskPaymentsComponent } from './kiosk/kiosk-payments/kiosk-payments.component';
import { KioskReportsComponent } from './kiosk/kiosk-reports/kiosk-reports.component';

export function createTranslateLoader(http: HttpClient) {
	return new TranslatePoHttpLoader(http, 'assets/i18n', '.po');
}

@NgModule({
	declarations: [
		AppComponent,
		OnclickoutDirective,
		InlineHrefDirective,
		LoginComponent,
		HomeComponent,
		SidebarComponent,
		HeaderComponent,
		FooterComponent,
		TextContentComponent,
		UserListComponent,
		AddUserComponent,
		EditUserComponent,
		MyProfileComponent,
		TranslateJsPipe,
		PaginationComponent,
		DatePickerComponent,
		PaginationComponent,
		ImagePipePipe,
		CookiePolicyComponent,
		TermsAndConditionsComponent,
		BrowserFailComponent,
		TinyMceComponent,
		TinyMceSmallEditorComponent,
		FooterConfigComponent,
		EditColumnComponent,
		SortPipe,
		FooterStyleConfigComponent,
		FooterColumnShiftComponent,
		FooterPagesComponent,
		FooterPageListComponent,
		HeaderBodyComponent,
		HeaderTopBarComponent,
		HeaderStyleConfigComponent,
		CategoriesListComponent,
		EditCategoryComponent,
		NewsIntranetComponent,
		EditNewsIntranetComponent,
		VisitingHoursComponent,
		AddEditDepartmentComponent,
		AddEditFieldComponent,
		NewsletterListComponent,
		NewsletterSubscribersComponent,
		NewsletterSettingsComponent,
		NewsletterAddSubscriberComponent,
		AddNewsletterComponent,
		GdprCreateSubscribeComponent,
		UnsubscribeNewsletterComponent,
		GdprComponent,
		SliderComponent,
		ShortFooterComponent,
		WelcomeComponent,
		FaqComponent,
		AddEditFaqComponent,
		KioskComponent,
		KioskPaymentsComponent,
		KioskReportsComponent,
		AddEditKioskComponent,
		AddEditTextContentComponent,
		UsefulContactsComponent,
		FooterListComponent,
		SliderListComponent,
		WelcomeListComponent,
		ForgotPasswordConfirmComponent,
		DepartmentsListComponent,
		AddEditAppointmentDepartmentComponent,
		AppointmentsListComponent,
		AddEditAppointmentComponent,
		AppointmentsOfficersListComponent,
		AddEditAppointmentOfficerComponent,
		ModuleSettingsComponent
		],
	imports: [
		BrowserModule.withServerTransition({ appId: 'serverApp' }),
		TranslateModule.forRoot({
			loader: {
				provide: TranslateLoader,
				useFactory: createTranslateLoader,
				deps: [HttpClient]
			}
		}),
		FormsModule,
		HttpClientModule,
		AppRoutingModule,
		BrowserAnimationsModule,
		TooltipModule,
		ImageCropperModule,
		QuillModule,
		InlineSVGModule,
		DragulaModule,
		ReactiveFormsModule,
		SimpleNotificationsModule.forRoot(),
		Ng2DeviceDetectorModule.forRoot(),
		ChartsModule,
		DateTimePickerModule,
		CalendarModule
	],
	providers: [IsUserLoggedGuard, DisableLoginGuard, LoginDataService, TokenInterceptor, UtilsService, UserListService, AddUserService, Globals, MessageService, InlineHrefDirective, { provide: HTTP_INTERCEPTORS, useClass: BasicAuthInterceptor, multi: true }],
	entryComponents: [LoginComponent, TextContentComponent],
	bootstrap: [AppComponent]
})
export class AppModule { }
